"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPermission = hasPermission;

var _enums = require("../enums");

const {
  DRAFT,
  TESTING,
  RUNNING,
  COMPLETED,
  CANCELLED
} = _enums.experimentStatusEnum;
const {
  EXPERIMENT_UPDATE,
  EXPERIMENT_UPDATE_RUNNING,
  EXPERIMENT_UPDATE_VERSION_RUNNING,
  EXPERIMENT_REPUBLISH,
  EXPERIMENT_TERMINATE,
  EXPERIMENT_DELETE,
  EXPERIMENT_DELETE_TESTING,
  PUBLISH_DEVELOPMENT,
  PUBLISH_ENGNEW,
  PUBLISH_ENGPROD,
  PUBLISH_PRODUCTION,
  TECH_UPDATE,
  ACTIVATION_UPDATE,
  OVERRIDE_UPDATE,
  OVERRIDE_DELETE
} = _enums.permissionEnum;
const {
  PRODUCTION
} = _enums.experimentEnvironmentEnum;

function findEnvStatus(environmentSamplings, env = PRODUCTION) {
  if (environmentSamplings === undefined) {
    return null;
  }

  const envSampling = environmentSamplings.find(sampling => sampling && sampling.environment && sampling.environment.id === env);

  if (!envSampling || !envSampling.experimentStatus) {
    return null;
  }

  const {
    experimentStatus: {
      id: envStatus
    }
  } = envSampling;
  return envStatus;
}

function doesPermissionExist(permissions, permissionId) {
  return permissions && permissions.find(perm => perm.id === permissionId) !== undefined;
}

function hasPermission({
  experimentTypeId,
  applicationPermissions,
  experimentPermissions,
  environmentSamplings,
  environmentId = PRODUCTION,
  permissionId
}) {
  // Always no, if the user doesn't have the permission
  if (!doesPermissionExist(applicationPermissions, permissionId) && !doesPermissionExist(experimentPermissions, permissionId)) {
    return false;
  }

  const envStatus = findEnvStatus(environmentSamplings, environmentId); // The following permissions depend on the env status of the experiment

  const envStatusDependentPermissions = {
    [EXPERIMENT_UPDATE]: [DRAFT, TESTING],
    [EXPERIMENT_UPDATE_RUNNING]: [RUNNING],
    [EXPERIMENT_REPUBLISH]: [TESTING, RUNNING],
    [EXPERIMENT_UPDATE_VERSION_RUNNING]: [RUNNING],
    [EXPERIMENT_TERMINATE]: [TESTING, RUNNING],
    [EXPERIMENT_DELETE]: [DRAFT, COMPLETED, CANCELLED],
    [EXPERIMENT_DELETE_TESTING]: [DRAFT, TESTING, COMPLETED, CANCELLED],
    [PUBLISH_DEVELOPMENT]: [DRAFT, TESTING],
    [PUBLISH_ENGNEW]: [DRAFT, TESTING],
    [PUBLISH_ENGPROD]: [DRAFT, TESTING],
    [PUBLISH_PRODUCTION]: [DRAFT, TESTING, RUNNING],
    [TECH_UPDATE]: [DRAFT, TESTING],
    [ACTIVATION_UPDATE]: [DRAFT, TESTING],
    [OVERRIDE_UPDATE]: [DRAFT, TESTING, RUNNING],
    [OVERRIDE_DELETE]: [DRAFT, TESTING, RUNNING]
  };
  const toCheck = envStatusDependentPermissions[permissionId];

  if (toCheck) {
    if (!envStatus) {
      throw new Error('Must pass envSampling for the supplied environmentId to determine whether you have this permission');
    } // Verify if experiment is canary and allowed permissions


    if (experimentTypeId === _enums.experimentTypeEnum.CANARY && (permissionId === EXPERIMENT_UPDATE_RUNNING || permissionId === TECH_UPDATE) && envStatus === RUNNING) {
      return true;
    }

    return toCheck.includes(envStatus);
  }

  return true;
}